<div class="container-fluid">
  <div class="card">
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <app-search-view>
            <app-user-search #app filters></app-user-search>
            <table class="table table-hover table-responsive-md table-wrap-sm-1" grid>
              <thead>
                <tr>
                  <th #name (click)="applySorting(name.id, app)" class="sort-field" id="name" scope="col">
                    <h3>First Name
                      <em class="{{ isDesc(name.id) ? 'fa fa-sort-desc': isAsc(name.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                    </h3>
                  </th>
                  <th #surname
                    (click)="applySorting(surname.id, app)"
                    class="sort-field"
                    id="surname"
                    scope="col">
                    <h3>
                      Last Name
                      <em class="{{ isDesc(surname.id) ? 'fa fa-sort-desc': isAsc(surname.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                    </h3>
                  </th>
                  <th scope="col"><h3>Email</h3></th>
                  <th scope="col"><h3>Mobile</h3></th>
                  <th scope="col"><h3>Role</h3></th>
                  <th scope="col"><h3>Status</h3></th>
                  <th class="text-center" scope="col"><h3>Edit</h3></th>
                </tr>
              </thead>
              <tbody class="table-hover">
                @for (user of userList; track user) {
                  <tr class="cursor-pointer active-color">
                    <td (click)="view(user)">
                      <span class="p-column-title">First Name</span>
                      {{ user.name }}
                    </td>
                    <td (click)="view(user)">
                      <span class="p-column-title">Last Name</span>
                      {{ user.surname }}
                    </td>
                    <td (click)="view(user)">
                      <span class="p-column-title">Email</span>
                      {{ user.email }}
                    </td>
                    <td (click)="view(user)">
                      <span class="p-column-title">Mobile</span>
                      {{ user.mobileNumber }}
                    </td>
                    <td (click)="view(user)">
                      <span class="p-column-title">Role</span>
                      {{ user.role.description }}
                    </td>
                    <td (click)="view(user)">
                      <span class="p-column-title">Status</span>
                      <h4 [ngClass]="{'user-active': user.enabled, 'user-inactive': !user.enabled} ">
                      {{ user.enabled ? 'ACTIVE' : 'INACTIVE' }} </h4>
                    </td>
                    <hr/>
                    <td>
                      <div class="text-center">
                        <div [pTooltip]="!isGuestAdminUser() && canEditUser(user) ? null : getEditTooltipMessage()"
                          class="disabled-tooltip-wrapper">
                          <div (click)="edit(user)"
                            [class.grey-circle-style]="isGuestAdminUser() || !canEditUser(user)"
                            class="circle-style">
                            <i class="fa fa-edit fa-lg"></i>
                          </div>
                        </div>
                        <span class="p-column-title ">Edit</span>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </app-search-view>
        </div>
      </div>
    </div>
  </div>
</div>